// extracted by mini-css-extract-plugin
export default {"price":"Price_price__ApkHR","crossed":"Price_crossed__rFypd","red":"Price_red__eTyNl"};